var map = {
	"./404.svg": "a14a",
	"./Cancel.svg": "c3df",
	"./activity.svg": "6736",
	"./add.svg": "c2a3",
	"./application.svg": "7f93",
	"./arrow.svg": "b6e4",
	"./back.svg": "c557",
	"./business.svg": "c1db",
	"./checkbox.svg": "8963",
	"./clientLatent.svg": "26c9",
	"./compony.svg": "0b90",
	"./dashboard.svg": "f782",
	"./dashboard2.svg": "ea93",
	"./edit.svg": "aa46",
	"./email.svg": "cbb7",
	"./filter.svg": "c886",
	"./form.svg": "eb1b",
	"./home.svg": "6bbe",
	"./info.svg": "4be3",
	"./menu.svg": "bd3d",
	"./menu2.svg": "e745",
	"./money.svg": "3046",
	"./more.svg": "3dd0",
	"./password-solid.svg": "538b",
	"./password.svg": "2a3d",
	"./pause.svg": "d46e",
	"./pic_book.svg": "43ad",
	"./play.svg": "fb4f",
	"./poweroff.svg": "d537",
	"./purchase.svg": "b8f7",
	"./refresh.svg": "b8c4",
	"./report.svg": "9e5c",
	"./search.svg": "8e8d",
	"./share.svg": "5306",
	"./shop-car.svg": "19f5",
	"./stock.svg": "2466",
	"./train.svg": "1f54",
	"./user-solid.svg": "f989",
	"./user.svg": "b3b5",
	"./v-menu.svg": "8551",
	"./video.svg": "8f2b",
	"./webcast.svg": "1805",
	"./wechat.svg": "80da",
	"./work.svg": "7bb0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";